import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminPrivateRoute = ({ children }) => {
  const globalState = useSelector((state) => state.AdminReducer);

  if (!globalState?.isAdminLoggedIn) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default AdminPrivateRoute;
